const FooterComponent = () => {
  return (
    <footer id="footer">
      <div className="container">
        <div className="copyright">
          <a href="https://universityofgalway.ie/">
            <img
              src="/assets/img/universityofgalway.jpg"
              alt="University of Galway"
            ></img>
          </a>
          <hr></hr>
          &copy; Copyright{" "}
          <strong>
            <span>University Galway Computer Society</span>
          </strong>
        </div>
        <div className="credits">
          Designed by{" "}
          <a href="https://bootstrapmade.com/" target="_blank" rel="noreferrer">
            BootstrapMade
          </a>
        </div>
      </div>
    </footer>
  );
};

export default FooterComponent;
